'use client';

import { usePathname } from 'next/navigation';
import { useLayoutEffect, useRef } from 'react';

export default function ScrollRestoration() {
  const pathname = usePathname();
  const previousPathname = useRef(pathname);

  useLayoutEffect(() => {
    const wasOnDiscover = previousPathname.current?.startsWith('/discover');
    const isOnSrp = pathname?.startsWith('/cars');

    if (wasOnDiscover && isOnSrp) {
      document.documentElement.style.scrollBehavior = 'auto';
      document.documentElement.scrollTop = 0;
      document.documentElement.style.scrollBehavior = '';
    }

    previousPathname.current = pathname;
  }, [pathname]);

  return null;
}
